import { entityAPI, logAPI } from "api/GenericAPI";
import { DirectMail , DirectMailLog } from "api/Interactions/InteractionsInterfaces";


// ================== API Factory ==================
export const directMailAPI = entityAPI<DirectMail>("interactions", "directmail");
export const directMailLogAPI = logAPI<DirectMailLog>("interactions", "directmail");
